import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDropzone',
  setup(__props) {

const DefaultDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/DefaultDropzone.vue"))
const ImageDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/ImageDropzone.vue"))
const SingleDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/SingleDropzone.vue"))
const MultiDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/MultiDropzone.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DefaultDropzone)),
      _createVNode(_unref(ImageDropzone)),
      _createVNode(_unref(SingleDropzone)),
      _createVNode(_unref(MultiDropzone))
    ])
  ]))
}
}

})